export default __webpack_public_path__ + "static/media/AdobeStock_48430476.9b393ee6.jpg";